export default __webpack_public_path__ + "static/media/effra_bold-webfont.e0dc64c0.woff2";